var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Mietwagenunternehmen",
          },
          on: { save: _vm.saveCarRentalCompanyFormData },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Mietwagenunternehmen",
                  "options-loader": _vm.loadCarRentalCompanyOptions,
                  property: "carRentalCompany",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm.firmData.name
                              ? _c("span", [
                                  _c("b", [_vm._v(_vm._s(_vm.firmData.name))]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.street
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.street)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.postalCode || _vm.firmData.city
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.firmData.postalCode) +
                                      " " +
                                      _vm._s(_vm.firmData.city)
                                  ),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.countryName
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.countryName)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.firmData.phone
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.phone)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.email
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + _vm.firmData.email,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.firmData.email))]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2679382243
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }